module.exports = __webpack_public_path__ + "img/news-geek.8d25c009.png";